export class PreviousNavigation {
  static key = 'uniskai-previous-navigation';
  static get() {
    const data = localStorage.getItem(PreviousNavigation.key);
    return data ? JSON.parse(data) : null;
  }

  static set(data: any) {
    localStorage.setItem(PreviousNavigation.key, JSON.stringify(data));
  }

  static remove() {
    localStorage.removeItem(PreviousNavigation.key);
  }
}
